"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ItemPool;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ItemPoolModule = _interopRequireDefault(require("./ItemPool.module.scss"));

var _Item = _interopRequireDefault(require("../Item/Item"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var BOX_WIDTH_UNIT_IN_PX = 32;
var BOX_HEIGHT_UNIT_IN_PX = 32;

function ItemPool(_ref) {
  var singleItem = _ref.singleItem,
      itemPool = _ref.itemPool,
      sizeX = _ref.sizeX,
      sizeY = _ref.sizeY,
      _ref$isOpaque = _ref.isOpaque,
      isOpaque = _ref$isOpaque === void 0 ? false : _ref$isOpaque,
      _ref$isTiled = _ref.isTiled,
      isTiled = _ref$isTiled === void 0 ? false : _ref$isTiled,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      style = _ref.style;

  if (itemPool && (itemPool.sizeX !== sizeX || itemPool.sizeY !== sizeY)) {
    throw new Error("itemPool with invalid size '".concat(itemPool.sizeX, "x").concat(itemPool.sizeY, "' was passed to ItemPool with '").concat(sizeX, "x").concat(sizeY, "'."));
  }

  var renderPooledItems = (0, _react.useCallback)(function () {
    var nodes = [];

    if (!itemPool) {
      throw new Error("Unable to render an itemPool that is undefined.");
    }

    itemPool.items.forEach(function (item) {
      var itemWrapperStyle = {
        marginLeft: "".concat((item.posX - 1) * BOX_WIDTH_UNIT_IN_PX, "px"),
        marginTop: "".concat((item.posY - 1) * BOX_HEIGHT_UNIT_IN_PX, "px")
      };
      nodes.push( /*#__PURE__*/_react.default.createElement("div", {
        key: "".concat(item.posX, "x").concat(item.posY),
        className: _ItemPoolModule.default.positionedItem,
        style: itemWrapperStyle
      }, /*#__PURE__*/_react.default.createElement(_Item.default, {
        item: item
      })));
    });
    return nodes;
  }, [itemPool]);
  var renderSingleItem = (0, _react.useCallback)(function () {
    if (!singleItem) {
      throw new Error("Unable to render single item within itempool. The item is undefined.");
    }

    var poolWidthPx = sizeX * BOX_WIDTH_UNIT_IN_PX;
    var poolHeightPx = sizeY * BOX_HEIGHT_UNIT_IN_PX;
    var itemWidthPx = singleItem.model.iconSizeX * BOX_WIDTH_UNIT_IN_PX;
    var itemHeigthPx = singleItem.model.iconSizeY * BOX_HEIGHT_UNIT_IN_PX;
    var paddingX = (poolWidthPx - itemWidthPx) / 2;
    var paddingY = (poolHeightPx - itemHeigthPx) / 2;
    var itemWrapperStyle = {
      width: "".concat(poolWidthPx, "px"),
      height: "".concat(poolHeightPx, "px")
    };
    var itemStyle = {
      padding: "".concat(paddingY, "px ").concat(paddingX, "px")
    };
    return /*#__PURE__*/_react.default.createElement("div", {
      className: _ItemPoolModule.default.positionedItem,
      style: itemWrapperStyle
    }, /*#__PURE__*/_react.default.createElement(_Item.default, {
      item: singleItem,
      style: itemStyle
    }));
  }, [sizeX, sizeY, singleItem]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_ItemPoolModule.default.itemPool, isOpaque && _ItemPoolModule.default.isOpaque, isTiled && _ItemPoolModule.default.isTiled, className),
    style: _objectSpread({
      width: "".concat(sizeX * BOX_WIDTH_UNIT_IN_PX, "px"),
      height: "".concat(sizeY * BOX_HEIGHT_UNIT_IN_PX, "px")
    }, style)
  }, itemPool && renderPooledItems(), singleItem && renderSingleItem());
}